import styled from "../../__compat__/styled-components/main.entry.mjs.mjs";
import { injectSpacing } from "../../api/spacing/injectSpacing.mjs.mjs";
export const StyledTagGroup = styled.div.withConfig({ displayName: "auir-611444a-StyledTagGroup", componentId: "auir-611444a-1v93v6u" }) `
  display: flex;
  flex-wrap: wrap;
  gap: var(${(props) => props.theme.responsive.spacing.xs});

  ${injectSpacing('margin')}
`;
//# sourceMappingURL=TagGroup.styles.mjs.mjs.map